/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Stop_Labels_Style_LabelInputs */

const fr_settings_stop_labels_style_label = /** @type {(inputs: Settings_Stop_Labels_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage des arrêts sur la carte`)
};

const en_settings_stop_labels_style_label = /** @type {(inputs: Settings_Stop_Labels_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop labels on the map`)
};

/**
* | output |
* | --- |
* | "Stop labels on the map" |
*
* @param {Settings_Stop_Labels_Style_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_stop_labels_style_label = /** @type {((inputs?: Settings_Stop_Labels_Style_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Stop_Labels_Style_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_stop_labels_style_label(inputs)
	return en_settings_stop_labels_style_label(inputs)
});